import { Box, Button, Card, CardContent, Chip, Stack, Typography } from '@mui/material';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

import React from 'react';

const PathCard = (props) => {
	const index = props.index;
	const kc = props.kc;
	return (
		<Card
			key={index}
			variant="outlined"
			sx={{ padding: 2, display: 'flex', flexDirection: 'row', minWidth: 350, maxWidth: 350 }}
		>
			<CardContent
				sx={{ width: '77%', display: 'flex', flexDirection: 'column', height: '100%' }}
			>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						// mb: '1',
						flexDirection: 'column',
						height: '100%',
						textAlign: 'left',
					}}
				>
					<Typography variant="subtitle1" fontWeight="bold">
						{kc.title || kc.subtopicName}
					</Typography>
					<Chip
						label={kc.mastery}
						color="error"
						size="small"
						sx={{ width: 'fit-content' }}
					/>
				</Box>

				{/* <Typography
                      variant="body2"
                      color="text.secondary"
                      gutterBottom
                    >
                      {kc.progress[0]}% → {kc.progress[1]}% → {kc.progress[2]}%
                    </Typography> */}

				{/* <Stack direction="row" spacing={2} mt={1}>
					<Button
						variant="contained"
						startIcon={<SearchIcon />}
						size="small"
						sx={{ backgroundColor: '#1a237e' }}
					>
						Learn
					</Button>
					<Button
						variant="contained"
						startIcon={<PlayArrowIcon />}
						size="small"
						sx={{ backgroundColor: '#1a237e' }}
					>
						Quiz
					</Button>
					<Button
						variant="contained"
						startIcon={<AssignmentIcon />}
						size="small"
						sx={{ backgroundColor: '#1a237e' }}
					>
						Flashcards
					</Button>
				</Stack> */}
			</CardContent>
			<Box sx={{ width: '30%' }}>
				<CircularProgressbar
					value={kc.progress}
					text={`${kc.progress}%`}
					strokeWidth={15}
					styles={buildStyles({
						pathColor:
							kc.progress === 100 ? 'green' : kc.progress > 60 ? '#48b7ff' : 'red',
						textColor: 'black',
					})}
				/>
			</Box>
		</Card>
	);
};

export default PathCard;
